var _epsilon = 1e-7;
export function epsilon() {
    return _epsilon;
}
export function setEpsilon(e) {
    _epsilon = e;
}
export function imageDataFormat() {
    return 'channelsLast';
}
//# sourceMappingURL=common.js.map